export default __webpack_public_path__ + "static/media/512px-JavaScript-logo.0e984e89.png";